module.exports = __webpack_public_path__ + "img/guide.993cf23f.svg";